import { render, staticRenderFns } from "./resume-item.vue?vue&type=template&id=65b7bef9&scoped=true"
import script from "./resume-item.vue?vue&type=script&lang=js"
export * from "./resume-item.vue?vue&type=script&lang=js"
import style0 from "./resume-item.vue?vue&type=style&index=0&id=65b7bef9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7bef9",
  null
  
)

export default component.exports